import { lazy } from "react";

export const SectionsPage = lazy(() => import("./sectionsPage"));
